import { Navigate } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "../contexts/AuthContext";
import { workspaceService } from "../lib/services";
import { useEffect, useState } from "react";

/**
 * Standalone redirect component for the "/" route.
 * Fetches the user's workspaces and redirects to the last-used or first one.
 * Does NOT use WorkspaceProvider — avoids circular dependency.
 */
export function WorkspaceRedirect() {
  const { session } = useAuth();
  const [targetId, setTargetId] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!session) return;
    workspaceService
      .list()
      .then((workspaces) => {
        const lastId = localStorage.getItem("showrunner:lastWorkspaceId");
        const match = lastId && workspaces.find((w) => w.id === lastId);
        setTargetId(match ? match.id : workspaces[0]?.id ?? null);
      })
      .catch(() => setFailed(true));
  }, [session?.access_token]);

  if (failed || targetId === null) {
    // No workspaces or fetch failed — still redirect, the workspace route
    // will show the appropriate error via WorkspaceContext
    if (failed) return <Navigate to="/login" replace />;
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  return <Navigate to={`/${targetId}/prompts`} replace />;
}
